import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormLabel,
  TextField,
} from "@mui/material";
import { t } from "i18next";
import { useState } from "react";

import { TransferListItem } from "../transferableList/TransferableList";
import "./TransferDialog.scss";
import useTransferAmountValidation from "./useTransferAmountValidation";

interface TransferDialogProps {
  showDialog: boolean;
  selectedItem: TransferListItem;
  closeDialog: () => void;
  handleTransfer: (quantityToTransfer: number) => void;
}

const TransferDialog = (props: TransferDialogProps) => {
  const { showDialog, selectedItem, closeDialog, handleTransfer } = props;

  const [quantityToTransfer, setQuantityToTransfer] = useState<string>(
    selectedItem.item.quantity.toString(),
  );

  const disableButton =
    !selectedItem?.item.quantity ||
    isNaN(Number(quantityToTransfer)) ||
    Number(quantityToTransfer) > selectedItem?.item.quantity ||
    Number(quantityToTransfer) <= 0;

  const validationError = useTransferAmountValidation({
    value: Number(quantityToTransfer),
    maxAmount: selectedItem.item.quantity,
  });

  const handleCloseDialog = () => {
    setQuantityToTransfer("");
    closeDialog();
  };

  const onClickTransfer = () => {
    handleTransfer(Number(quantityToTransfer));
    handleCloseDialog();
  };

  return (
    <Dialog
      className="transfer-dialog"
      open={showDialog}
      onClose={handleCloseDialog}
    >
      <DialogTitle>{t("transferQuantity")}</DialogTitle>
      <DialogContent className="transfer-dialog-content">
        <FormLabel required>{t("quantity")}</FormLabel>
        <TextField
          type="number"
          id={"quantityToTransfer"}
          className="input-element"
          value={quantityToTransfer}
          onChange={(e) => setQuantityToTransfer(e.target.value)}
          variant="outlined"
          required
          error={!!validationError}
          helperText={validationError}
          onKeyDown={(e) => {
            if (disableButton) return;
            e.key === "Enter" && onClickTransfer();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog} color="primary">
          {t("cancel")}
        </Button>
        <Button
          disabled={disableButton}
          onClick={onClickTransfer}
          color="primary"
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransferDialog;
